// extracted by mini-css-extract-plugin
export default {"root":"Search_root__8tGZX","input":"Search_input__nFDTP","icon":"Search_icon__Oiwnt","clearIcon":"Search_clearIcon__jNbJP"};